var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchbackFrame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 472,
    height: 508,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M472 397.586V64.664c0-7.732-6.268-14-14-14h-75.126c-7.732 0-14 6.268-14 14v318.922c0 7.732-6.268 14-14 14H58.848c-7.732 0-14 6.268-14 14V494c0 7.732 6.268 14 14 14H458c7.732 0 14-6.268 14-14v-96.414z",
    fill: "#E1F7FD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 433.604,
    y: 474,
    width: 430.604,
    height: 471,
    rx: 13,
    transform: "rotate(-180 433.604 474)",
    stroke: "#00AECF",
    strokeWidth: 6
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDcyIiBoZWlnaHQ9IjUwOCIgdmlld0JveD0iMCAwIDQ3MiA1MDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik00NzIgMzk3LjU4Nkw0NzIgNjQuNjYzN0M0NzIgNTYuOTMxOCA0NjUuNzMyIDUwLjY2MzggNDU4IDUwLjY2MzhMMzgyLjg3NCA1MC42NjM3QzM3NS4xNDIgNTAuNjYzNyAzNjguODc0IDU2LjkzMTggMzY4Ljg3NCA2NC42NjM3TDM2OC44NzQgMzgzLjU4NkMzNjguODc0IDM5MS4zMTggMzYyLjYwNiAzOTcuNTg2IDM1NC44NzQgMzk3LjU4Nkw1OC44NDggMzk3LjU4NkM1MS4xMTYgMzk3LjU4NiA0NC44NDggNDAzLjg1NCA0NC44NDggNDExLjU4Nkw0NC44NDggNDk0QzQ0Ljg0OCA1MDEuNzMyIDUxLjExNiA1MDggNTguODQ4IDUwOEwzNjguODc0IDUwOEw0NTggNTA4QzQ2NS43MzIgNTA4IDQ3MiA1MDEuNzMyIDQ3MiA0OTRMNDcyIDM5Ny41ODZaIiBmaWxsPSIjRTFGN0ZEIi8+CjxyZWN0IHg9IjQzMy42MDQiIHk9IjQ3NCIgd2lkdGg9IjQzMC42MDQiIGhlaWdodD0iNDcxIiByeD0iMTMiIHRyYW5zZm9ybT0icm90YXRlKC0xODAgNDMzLjYwNCA0NzQpIiBzdHJva2U9IiMwMEFFQ0YiIHN0cm9rZS13aWR0aD0iNiIvPgo8L3N2Zz4K";
export { SvgSwitchbackFrame as ReactComponent };